'use client';

var S = {"NormalStatus":"SelectedTag-module_NormalStatus__3nN0K","wrapIcon":"SelectedTag-module_wrapIcon__3TBpH","NormalStatusHover":"SelectedTag-module_NormalStatusHover__1qi18","ReviewingStatus":"SelectedTag-module_ReviewingStatus__2_fAr","ReviewingStatusHover":"SelectedTag-module_ReviewingStatusHover__2jCT9","DeletedTag":"SelectedTag-module_DeletedTag__1BE_7"};

export { S as default };
//# sourceMappingURL=SelectedTag.module.css.js.map
